'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _component = require('../component');

var _component2 = _interopRequireDefault(_component);

var _domPatcher = require('../dom-patcher');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Definition of a generic Component which proxies attributes and events
 * between itself and a variable child component.
 *
 * @extends Component
 */
var ProxyComponent = function (_Component) {
  _inherits(ProxyComponent, _Component);

  function ProxyComponent() {
    _classCallCheck(this, ProxyComponent);

    return _possibleConstructorReturn(this, (ProxyComponent.__proto__ || Object.getPrototypeOf(ProxyComponent)).apply(this, arguments));
  }

  _createClass(ProxyComponent, [{
    key: 'getTargetElementTag',


    /**
     * Override to determine which tag to instantiate as the child.
     *
     * This is where all switching logic should go.
     *
     * @returns {string} - tag name of the component to instantiate
     *
     * @example <caption>a URL based feature flag</caption>
     * class MyWidget extends ProxyComponent {
     *   getTargetElementTag() {
     *     if (window.location.search.includes('enable_beta') {
     *       return 'my-widget-v2';
     *     }
     *
     *     return 'my-widget-v1'
     *   }
     * }
     */
    value: function getTargetElementTag() {
      throw new Error('You must override getTargetElementTag().');
    }
  }, {
    key: '_getProxiedEventHandlers',
    value: function _getProxiedEventHandlers() {
      var handler = this.proxyEventHandler.bind(this);
      return this.observedEvents.reduce(function (acc, ev) {
        acc[ev] = handler;
        return acc;
      }, {});
    }

    /**
     * Override this method to stop events from being bubbled through this element.
     * @param {Event} ev - event to check
     * @returns {boolean} whether event should bubble through
     *
     * @example <caption>filter specific events out</caption>
     * class MyWidget extends ProxyComponent {
     *   allowEvent(ev) {
     *     // don't propagate click events for the v2 component
     *     return this.getTargetElementTag() !== `my-widget-v2` && ev.type !== `click`;
     *   }
     * }
     */

  }, {
    key: 'allowEvent',
    value: function allowEvent(ev) {
      // eslint-disable-line no-unused-vars
      return true;
    }

    // Proxied events will be stripped of their native attributes and re-wrapped as CustomEvents. Callers
    // should assume that only `detail` remains intact.

  }, {
    key: 'proxyEventHandler',
    value: function proxyEventHandler(ev) {
      if (!this.allowEvent(ev)) {
        return false;
      }

      if (!ev.bubbles) {
        this.dispatchEvent(new CustomEvent(ev.type, ev));
      }

      return true;
    }

    // Return a map of attributes to pass to the child.

  }, {
    key: 'getAttributes',
    value: function getAttributes() {
      var attributes = {};
      for (var i = 0; i < this.attributes.length; i++) {
        var attr = this.attributes[i];
        attributes[attr.name] = attr.value;
      }

      return attributes;
    }

    /**
     * Defines the names of events which will be emitted by the wrapped component.
     * Bubbling events will bubble through, but non-composed events from ShadowDOM
     * elements will not and will be re-dispatched from the proxy.
     * @type {string[]}
     */

  }, {
    key: 'config',
    get: function get() {
      return Object.assign({
        template: function template(_ref) {
          var $component = _ref.$component;

          return (0, _domPatcher.h)($component.getTargetElementTag(), {
            attrs: $component.getAttributes(),
            on: $component._getProxiedEventHandlers()
          });
        }
      }, this.localConfig);
    }

    /**
     * Override this to extend the default configuration.
     *
     * @see Component#config
     */

  }, {
    key: 'localConfig',
    get: function get() {
      return {};
    }
  }, {
    key: 'observedEvents',
    get: function get() {
      return [];
    }
  }]);

  return ProxyComponent;
}(_component2.default);

exports.default = ProxyComponent;


//////////////////
// WEBPACK FOOTER
// ../node_modules/panel/build/component-utils/proxy-component.js
// module id = 190
// module chunks = 0 1 2 3 4 8 9 10 11 12 20 21 22 23 24 25 26 27 28 34 38 39